import DrIndex from './DrIndex'
export default DrIndex
